import IdvSpinner from './IdvSpinner';

export default IdvSpinner;
